import { render, staticRenderFns } from "./storeModel.vue?vue&type=template&id=3af6c972&scoped=true&"
import script from "./storeModel.vue?vue&type=script&lang=js&"
export * from "./storeModel.vue?vue&type=script&lang=js&"
import style0 from "./storeModel.vue?vue&type=style&index=0&id=3af6c972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6c972",
  null
  
)

export default component.exports